<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle" :bordered="false">
        <div class="table-operator">
          <a-button v-if="btnEnableList.indexOf(1)>-1" type="primary" icon="plus" @click="handleAdd">新增</a-button>
          <span class="advert-tip">副屏广告按排序轮播：图片按时长切换、视频播放完或到时切下一条；无可用广告显示默认欢迎页</span>
        </div>
        <a-table
          ref="table"
          size="middle"
          bordered
          rowKey="id"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="false"
          :loading="loading">
          <template slot="mediaSlot" slot-scope="text, record">
            <img v-if="record.mediaType === 'image'" :src="imgUrl(record.mediaUrl)" class="media-thumb" />
            <a v-else :href="imgUrl(record.mediaUrl)" target="_blank"><a-icon type="video-camera" /> 视频预览</a>
          </template>
          <template slot="typeSlot" slot-scope="text, record">
            <a-tag :color="record.mediaType === 'video' ? 'purple' : 'blue'">{{ record.mediaType === 'video' ? '视频' : '图片' }}</a-tag>
          </template>
          <template slot="enabledSlot" slot-scope="text, record">
            <a-tag :color="record.enabled === '1' ? 'blue' : 'red'">{{ record.enabled === '1' ? '启用' : '停用' }}</a-tag>
          </template>
          <span slot="action" slot-scope="text, record">
            <a v-if="btnEnableList.indexOf(1)>-1" @click="handleEdit(record)">编辑</a>
            <a-divider v-if="btnEnableList.indexOf(1)>-1 && btnEnableList.indexOf(4)>-1" type="vertical" />
            <a v-if="btnEnableList.indexOf(4)>-1" @click="handleToggle(record)">{{ record.enabled === '1' ? '停用' : '启用' }}</a>
            <a-divider v-if="btnEnableList.indexOf(1)>-1 && btnEnableList.indexOf(4)>-1" type="vertical" />
            <a-popconfirm v-if="btnEnableList.indexOf(1)>-1" title="确定删除该广告吗？" @confirm="() => handleDelete(record.id)">
              <a>删除</a>
            </a-popconfirm>
          </span>
        </a-table>
        <advert-modal ref="modalForm" @ok="modalFormOk"></advert-modal>
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
import AdvertModal from './modules/AdvertModal'
import { advertDelete, advertToggle } from '@/api/plugin/member'
import { getFileAccessHttpUrl } from '@/api/manage'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'

/**
 * 副屏广告配置（2804）：素材（图片/视频，共用上传）/排序/时长/启停
 */
export default {
  name: 'AdvertList',
  mixins: [JeecgListMixin],
  components: {
    AdvertModal
  },
  data() {
    return {
      // 按钮权限匹配键，须与菜单URL一致（JeecgListMixin.initActiveBtnStr 按 urlPath 匹配 winBtnStrList）
      urlPath: '/plugin/member/advert',
      queryParam: {},
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        { title: '素材', dataIndex: 'mediaUrl', width: 180, align: 'center', scopedSlots: { customRender: 'mediaSlot' } },
        { title: '类型', dataIndex: 'mediaType', width: 80, align: 'center', scopedSlots: { customRender: 'typeSlot' } },
        { title: '备注名', dataIndex: 'title', width: 160, customRender: function(text) { return text || '-' } },
        { title: '排序', dataIndex: 'sortNo', width: 70, align: 'center' },
        { title: '时长(秒)', dataIndex: 'duration', width: 90, align: 'center' },
        { title: '状态', dataIndex: 'enabled', width: 80, align: 'center', scopedSlots: { customRender: 'enabledSlot' } },
        { title: '操作', dataIndex: 'action', width: 180, align: 'center', scopedSlots: { customRender: 'action' } }
      ],
      url: {
        list: '/api/plugin/member/adverts'
      }
    }
  },
  methods: {
    imgUrl(path) {
      return getFileAccessHttpUrl('systemConfig/static/' + path)
    },
    handleAdd() {
      this.$refs.modalForm.add()
    },
    handleEdit(record) {
      this.$refs.modalForm.edit(record)
    },
    handleToggle(record) {
      advertToggle(record.id).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message)
          this.loadData()
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    handleDelete(id) {
      advertDelete(id).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message)
          this.loadData()
        } else {
          this.$message.warning(res.message)
        }
      })
    }
  }
}
</script>
<style scoped>
.table-operator { margin-bottom: 15px; }
.advert-tip { color: #999; font-size: 12px; margin-left: 12px; }
.media-thumb { max-height: 48px; max-width: 120px; border-radius: 4px; border: 1px solid #eee; }
</style>
